export default "__VITE_ASSET__1d0140a4__"